/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/react-in-jsx-scope */
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Spinner from "../../../../components/Spinner";
import { toastError, toastWarn } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { convertHoursIntoSeconds, currentDate, currentHours, _formatDate } from "../../../../libs/dateUtils";
import { isErrorFormField, treatFieldsToSave } from "../../lib";
import { ClientsUserId, Points, ProjectsUserId, TimeSheetProps } from "../../model";
import { getClientsUserId, getPointsByDay, getProjectsByClient, savePoints } from "../../service";

import "./index.scss";
import FieldArrayComponent, { IClient } from "./FieldArray";
import IconButton from "../../../../components/IconButton";
import { IconLeftArrowVersion2, IconMoon, IconSun } from "../../../../icons";
import Input from "../../../../components/Input";
import Title from "../../../../components/Title";

const points = [{ date: _formatDate(currentDate()), clientId: undefined, projectId: 0, entrance: currentHours(), exit: null }];

const initialValue: TimeSheetProps = {
  points: points,
};

export default function FormTimeSheet(props: any) {
  const { token, userId } = useAuthData();
  const [listClient, setListClient] = useState([] as ClientsUserId[]);
  const [formValues, setFormValues] = useState(initialValue as TimeSheetProps);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [modo, setModo] = useState<"create" | "update">("create");
  const [error, setError] = useState(true);
  const history = useHistory();
  const params: any = props.match.params.id;
  const [autoFillDisabledDay, setAutoFillDisabledDay] = useState(false);
  const [autoFillDisabledNight, setAutoFillDisabledNight] = useState(false);
  const [clientValue, setClientValue] = useState<IClient[]>();

  const [filterDate, setFilterDate] = useState(_formatDate(currentDate()));

  useEffect(() => {
    getClientsUser();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [formValues]);

  async function getClientsUser(): Promise<void> {
    const data: ClientsUserId[] = await getClientsUserId(token);
    setListClient(data);
    getPoints(params || undefined, data);
  }

  async function getPoints(date: string = _formatDate(currentDate()), clients: ClientsUserId[] = []) {
    setNeedSpinner(true);
    setFilterDate(date);
    setAutoFillDisabledDay(false);
    setAutoFillDisabledNight(false);
    getPointsByDay(token, userId, date)
      .then(async (data: TimeSheetProps) => {
        setNeedSpinner(true);
        if (!data) return setNeedSpinner(false);
        if (data.points?.length !== 0) return await startUpdateModo(data, date, clients);
        startCreateModo();
      })
      .catch((error) => console.error(error));
  }

  function startCreateModo() {
    setModo("create");
    setFormValues({
      points: [
        {
          date: filterDate,
          clientId: undefined,
          projectId: 0,
          entrance: currentHours(),
          exit: null,
        },
      ],
    });
  }

  async function startUpdateModo(data: TimeSheetProps, date: string, clients: ClientsUserId[]) {
    setModo("update");
    const dataAutoComplete = autoCompleteTimeSheet(data, date);
    await updateClientValue(dataAutoComplete, clients);
    setFormValues(dataAutoComplete);
  }

  async function updateClientValue(data, clients: ClientsUserId[]) {
    let newClientValue = [];
    let index = 0;
    for (let point of data?.points) {
      const project = await getProjectsByClient(token, point?.clientId);
      const clientName = clients?.find((client) => client?.id === point.clientId)?.name;
      newClientValue.push({ index, clientName, idClient: point?.clientId, project: project, projectId: point?.projectId });
      index++;
    }
    setClientValue(newClientValue);
  }

  async function handleFormSubmit(value: TimeSheetProps) {
    const dataForm = treatFieldsToSave(value, userId);
    const dataFormWithoutClientId = dataForm?.points
      ?.map((point, index) => {
        const projectId = +clientValue?.find((item) => item?.index === index)?.projectId;
        if (!projectId)
          return {
            errorMessage: `Projeto é obrigatório, favor adicionar projeto na linha ${index + 1}`,
            error: true,
          };
        return {
          entrance: point?.entrance,
          exit: point?.exit,
          date: point?.date,
          projectId,
          clientId: point?.clientId,
          observation: point?.observation
        };
      })
      ?.filter(Boolean);
    const isError = isErrorFormField(dataFormWithoutClientId);
    const isValid = isValidFields(value.points);
    const withoutProject = dataFormWithoutClientId?.find((item) => item.error);
    if (isError || isValid) return toastError("Campo inválido!");
    if (withoutProject?.error) return toastError(withoutProject.errorMessage);
    const pointsOfSave = { points: dataFormWithoutClientId, userId, date: filterDate };
    const data = await savePoints(pointsOfSave as TimeSheetProps, token);
    if (!data?.ok) return toastError("Erro em salvar!");
    return history.push("/timesheet");
  }

  function isValidFields(points: Points[]) {
    let countError = 0;
    points?.forEach((point) => {
      const exitInMilliseconds = convertHoursIntoSeconds(point.exit);
      const entranceInMilliseconds = convertHoursIntoSeconds(point.entrance);
      if (point?.exit && exitInMilliseconds < entranceInMilliseconds) {
        countError++;
      }
    });
    return Boolean(countError);
  }

  function handleArrowClick() {
    history.push("/timesheet");
  }

  return (
    <div className="timesheetContainer px-8 sm:mt-32">
      <Spinner status={needSpinner}>
        <div className="flex content-center">
          <IconButton onClick={handleArrowClick} className="title-arrow pointer flex" icon={IconLeftArrowVersion2} />
          <Title title={`Time Sheet: ${modo === "create" ? "Novo Registro" : "Atualizar Registro"}`}></Title>
        </div>
        {/* <div className="form-box-title title-form">
          <h1 className="row font-source-sans-pro color-text-black">Time Sheet - {modo === "create" ? "Novo Registro" : "Atualizar Registro"}</h1>
        </div> */}
        <Toaster />

        <Formik
          initialValues={formValues}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
        >
          {(props) => (
            <>
              <div className="form-timesheet-header box-shadow form-box-title center rowTitle button-auto">
                <div className="flex center">
                  <Input
                    value={filterDate}
                    name={`filterDate`}
                    label="Filtrar por Data"
                    className="inputDate"
                    type="date"
                    placeholder="DD/MM/AAAA"
                    setValue={(e: any) => setFilterDate(e.target.value)}
                    onBlur={(e) => {
                      getPoints(e.target.value);
                    }}
                  />
                </div>
                <div className="auto-box flex column center">
                  <span className="font-roboto color-text">Auto</span>
                  <div className="flex gap">
                    <IconButton
                      className={`icon-auto-period period-day image-contrast pointer 
                        ${autoFillDisabledDay && "disabled icon-auto-period-disabled"}
                        ${!listClient?.length && "disabled icon-auto-period-disabled"}
                      `}
                      icon={IconSun}
                      onClick={() => {
                        if (autoFillDisabledDay || !listClient?.length) return;
                        autoFillDay(formValues?.points);
                      }}
                    />
                    <IconButton
                      className={`icon-auto-period period-night pointer
                        ${autoFillDisabledNight && "disabled icon-auto-period-disabled"} 
                        ${!listClient?.length && "disabled icon-auto-period-disabled"}
                        `}
                      icon={IconMoon}
                      onClick={() => {
                        if (autoFillDisabledNight || !listClient?.length) return;
                        autoFillNight(formValues?.points);
                      }}
                    />
                  </div>
                </div>
              </div>

              <form className="form-container box-form border-radius-bottom" onSubmit={props.handleSubmit}>
                <FieldArrayComponent
                  name="points"
                  props={props}
                  errorStatus={setError}
                  listClient={listClient}
                  clientValue={clientValue}
                  setClientValue={setClientValue}
                />
                <div className="buttonContainer buttonSubmit">
                  <button className="btn bg-secondary color-text-contrast" type="button" onClick={handleConfirmClick}>
                    Cancelar
                  </button>
                  {error ? (
                    <button type="button" className="btn bg-primary disabled" disabled>
                      {" "}
                      {modo === "create" ? "Salvar" : "Atualizar"}
                    </button>
                  ) : (
                    <button type="submit" className="btn bg-primary ">
                      {" "}
                      {modo === "create" ? "Salvar" : "Atualizar"}
                    </button>
                  )}
                </div>
              </form>
            </>
          )}
        </Formik>
      </Spinner>
    </div>
  );

  function autoCompleteTimeSheet(data: TimeSheetProps, date) {
    if (!data.points[data.points?.length - 1].exit) {
      data.points[data.points?.length - 1].exit = currentHours();
    } else {
      data.points[data.points?.length] = {
        date,
        clientId: undefined,
        projectId: 0,
        entrance: currentHours(),
        exit: null,
      };
    }
    return data;
  }

  function handleConfirmClick() {
    props.history.push("/timesheet");
  }

  async function autoFillDay(oldPoints: any = []) {
    if (!listClient?.length) return toastWarn("É necessários estar alocado em um cliente para usar essa função");
    setAutoFillDisabledDay(true);
    const projects = await getProjectsByClient(token, listClient[0]?.id);
    const clientValueWithouthUndefined = clientValue?.filter((item) => item?.idClient) || [];

    const points = [
      ...oldPoints,
      {
        date: filterDate,
        clientId: listClient[0]?.id,
        projectId: projects[0]?.id,
        entrance: "09:00:00",
        exit: "12:00:00",
      },
      {
        date: filterDate,
        clientId: listClient[0]?.id,
        projectId: projects[0]?.id,
        entrance: "13:00:00",
        exit: "18:00:00",
      },
    ];

    const newClientValue: IClient[] = [
      ...clientValueWithouthUndefined,
      {
        index: clientValueWithouthUndefined?.length,
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        project: projects,
        projectId: projects[0]?.id,
      },
      {
        index: clientValueWithouthUndefined?.length + 1,
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        project: projects,
        projectId: projects[0]?.id,
      },
    ];

    const newPoints: TimeSheetProps["points"] = points?.filter((point) => !!point?.exit); //?.filter((point) => !!point?.projectId)
    setNeedSpinner(true);
    setClientValue(newClientValue);
    setFormValues({
      ...formValues,
      points: newPoints,
    });
  }

  async function autoFillNight(oldPoints) {
    if (!listClient?.length) return toastWarn("É necessários estar alocado em um projeto para usar essa função");
    setAutoFillDisabledNight(true);
    const projects = await getProjectsByClient(token, listClient[0]?.id);
    const clientValueWithouthUndefined = clientValue?.filter((item) => item?.idClient) || [];
    const formatDay = (day: number): string => ("0" + day)?.slice(-2);
    const [year, month, day] = filterDate?.split("-");
    const nextDay = `${year}-${month}-${formatDay(+day + 1)}`;

    const points = [
      ...oldPoints,
      {
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        date: _formatDate(`${year}-${month}-${formatDay(+day)}`),
        projectId: projects[0]?.id,
        entrance: "21:00:00",
        exit: "23:59:00",
      },
      {
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        date: _formatDate(nextDay),
        projectId: projects[0]?.id,
        entrance: "00:00:00",
        exit: "01:00:00",
      },
      {
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        date: _formatDate(nextDay),
        projectId: projects[0]?.id,
        entrance: "02:00:00",
        exit: "06:00:00",
      },
    ];

    const newClientValue: IClient[] = [
      ...clientValueWithouthUndefined,
      {
        index: clientValueWithouthUndefined?.length,
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        project: projects,
        projectId: projects[0]?.id,
      },
      {
        index: clientValueWithouthUndefined?.length + 1,
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        project: projects,
        projectId: projects[0]?.id,
      },
      {
        index: clientValueWithouthUndefined?.length + 2,
        clientName: listClient[0]?.name,
        idClient: listClient[0]?.id,
        project: projects,
        projectId: projects[0]?.id,
      },
    ];

    const newPoints: TimeSheetProps["points"] = points?.filter((point) => !!point.projectId)?.filter((point) => !!point?.exit);
    setNeedSpinner(true);
    setClientValue(newClientValue);
    setFormValues({
      ...formValues,
      points: newPoints,
    });
  }
}
